

import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const editStpTimeSheetRole = async (params) => {
    return await api.post("/v1/stpTimeSheet/editStpTimeSheetRole", params);
};

export const getStpTimeSheetRoleList = async (params) => {
    return await api.post("/v1/stpTimeSheet/getStpTimeSheetRoleList", params);
};
export const updateStpTimeSheetRoleStatusFlag = async (params) => {
    return await api.post("/v1/stpTimeSheet/updateStpTimeSheetRoleStatusFlag", params);
};

export const editStpTimeSheet = async (params) => {
    return await api.post("/v1/stpTimeSheet/editStpTimeSheet", params);
};
export const getStpTimeSheetPagination = async (params) => {
    return await api.post("/v1/stpTimeSheet/getStpTimeSheetPagination", params);
};
export const getStpTimeSheetById = async (params) => {
    return await api.post("/v1/stpTimeSheet/getStpTimeSheetById", params);
};
export const updateStpTimeSheetStatusFlag = async (params) => {
    return await api.post("/v1/stpTimeSheet/updateStpTimeSheetStatusFlag", params);
};
export const editStpTimeSheetTask = async (params) => {
    return await api.post("/v1/stpTimeSheet/editStpTimeSheetTask", params);
};
export const dropdownTask = async (params) => {
    return await api.post("/v1/stpTimeSheet/dropdownTaskByRole", params);
};
export const taskGroupByRoleList = async (params) => {
    return await api.post("/v1/stpTimeSheet/taskGroupByRole", params);
};
export const dropdownEmployee = async (params) => {
    return await api.post("/v1/dropdown/getEmployee", params);
};

export const dropdownRoleByProject = async (params) => {
    return await api.post("/v1/stpTimeSheet/dropdownRoleByProject", params);
};

export const dropdownTimeSheetRole = async (params) => {
    return await api.post("/v1/stpTimeSheet/getStpTimeSheetRoleDropdown", params);
};

export const dropdownCompanyRole = async (params) => {
    return await api.post("/v1/dropdown/getAllRoleByCompanyId", params);
};

export const mappingEmployeeAndStpTimeSheetRole = async (params) => {
    return await api.post("/v1/stpTimeSheet/mappingEmployeeAndStpTimeSheetRole", params);
};
export const getEmployeeRoleMappingPagination = async (params) => {
    return await api.post("/v1/stpTimeSheet/getEmployeeRoleMappingPagination", params);
};
export const getEmployeePaginationByRoleIdAndTimeSheetId = async (params) => {
    return await api.post("/v1/stpTimeSheet/getEmployeePaginationByRoleIdAndTimeSheetId", params);
};
export const deleteStpTimeSheetById = async (params) => {
    return await api.post("/v1/stpTimeSheet/deleteStpTimeSheetById", params);
};
export const removeEmployeeFromRole = async (params) => {
    return await api.post("/v1/stpTimeSheet/removeEmployeeFromRole", params);
};

export const getProjectWorkflowList = async (params) => {
    return await api.post("v1/stpTimeSheet/getWorkFlowTimeSheet", params);
};

export const editProjectWorkFlow = async (params) => {
    return await api.post("v1/stpTimeSheet/editWorkFlowTimeSheet", params);
};

export const deleteTaskAndRole = async (params) => {
    return await api.post("/v1/stpTimeSheet/deleteTaskAndRole", params);
};

export const deleteTaskById = async (params) => {
    return await api.post("/v1/stpTimeSheet/deleteStpTimeSheetTaskById", params);
};